// extracted by css-extract-rspack-plugin
export default {"title":"sfhtj","description":"iZ5Qp"};